export default "__VITE_ASSET__B39r$uJd__"